import {logger} from '../../shared/logger';
import {Action, Dispatch, Middleware, MiddlewareAPI} from 'redux';
import { TransactionReceipt } from 'ethers';
import {AppState} from '../store';
import {
  ADD_TRANSACTION,
  FINISH_TRANSACTION,
  TransactionActionTypes,
  UPDATE_TRANSACTIONS,
} from '../../types/actions/Transaction.actions';
import {showError, showMessage} from '../actions';
import {LOGIN_SUCCESS, LoginSuccess} from 'types/actions/Auth.actions';

const callbacks: {[hash: string]: (isSucceed: boolean) => void} = {};
const queued: string[] = [];

export const createTransactionMiddleware = (): Middleware => ({
  dispatch,
  getState,
}: MiddlewareAPI<Dispatch, AppState>) => (next: Dispatch) => (
  action: TransactionActionTypes | LoginSuccess,
): Action | void => {
  if (action.type === ADD_TRANSACTION && action.onComplete) {
    callbacks[action.hash] = action.onComplete;
  }
  if (action.type !== UPDATE_TRANSACTIONS && action.type !== ADD_TRANSACTION) {
    if (action.type === LOGIN_SUCCESS) {
      dispatch({type: 'UPDATE_TRANSACTIONS'});
    }
    return next(action);
  }

  const {transactions, web3} = getState();
  if (
    !transactions.pending.length &&
    action.type !== ADD_TRANSACTION &&
    web3.provider
  ) {
    return;
  }

  if (action.type === ADD_TRANSACTION) {
    transactions.pending.push(action.hash);
  }

  transactions.pending
    .filter((hash) => !queued.some((qHash) => hash === qHash))
    .forEach((hash) => {
      queued.push(hash);
      web3.provider?.waitForTransaction(hash)
        .then((result: TransactionReceipt | null) => {
          if (!result) {
            return;
          }
          dispatch({
            type: FINISH_TRANSACTION,
            hash,
            payload: {
              confirmedTime: Date.now(),
              status: result.status,
            },
          });

          const data = transactions.data[hash];
          if (result.status) {
            dispatch(showMessage(data.completeMessage || data.summary));
          } else {
            dispatch(showError(data.errorMessage || data.summary));
          }

          if (callbacks[hash]) {
            callbacks[hash](Boolean(result.status));
          }
        })
        .catch((error: any) => {
          logger.error("Transaction wait error:", error);
          const data = transactions.data[hash];
          
          dispatch({
            type: FINISH_TRANSACTION,
            hash,
            payload: {
              confirmedTime: Date.now(),
              status: 0,
            },
          });

          const errorMessage = error?.message ? `Network Error: ${error.message}` : (data.errorMessage || data.summary);
          dispatch(showError(errorMessage));

          if (callbacks[hash]) {
            callbacks[hash](false);
          }
        });
    });

  if (action.type === ADD_TRANSACTION) {
    return next(action);
  }
};
